import { render, staticRenderFns } from "./EditTest.vue?vue&type=template&id=bdec4996&"
import script from "./EditTest.vue?vue&type=script&lang=js&"
export * from "./EditTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports